export default __webpack_public_path__ + "static/media/parkeasy6.b19015cd.png";